module.exports = __webpack_public_path__ + "static/media/failed-payment.870239a0.jpg";